<template>
  <transition name="transition-height" @enter="enter" @leave="leave">
    <slot />
  </transition>
</template>
<script setup>
import { gsap } from '@gsap/shockingly';

import { animationFrame } from '@/shared/js/utils/animation';

import { ref } from 'vue';

const firstTime = ref(true);

const enter = async (el, done) => {
  if (firstTime.value) {
    el.style.height = 0;
    await animationFrame();
    firstTime.value = false;
  }
  gsap.fromTo(el, { height: 0 }, { height: 'auto', onComplete: done });
};

const leave = async (el, done) => {
  gsap.to(el, { height: 0, onComplete: done });
};
</script>
